import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-white-space',
  templateUrl: './white-space.component.html',
  styleUrls: ['./white-space.component.scss']
})
export class WhiteSpaceComponent extends FieldType<FieldTypeConfig> {
}
